import CryptoJS from 'crypto-js';

function encryptData(key, data) {
  const jsonString = JSON.stringify(data);

  const encryptedData = CryptoJS.AES.encrypt(jsonString, key).toString();

  return encodeURIComponent(encryptedData);
}

export default (key) => {
  const encrypt = (data) => {
    return encryptData(key, data);
  };

  return {
    encrypt,
  };
};
